// TODO enable eslint
/* eslint-disable import/no-self-import */
import * as thisModule from "./constraintType"

export const getId = constraintType => constraintType.id
export const getCategory = constraintType => constraintType.category
export const getName = constraintType => constraintType.name
export const getForm = constraintType => constraintType.form

export const getArgumentLabel = argument => argument.label
export const getArgumentType = argument => argument.type
export const getArgumentName = argument => argument.name
export const getArgumentOptions = argument => argument.options
export const isArgumentRequired = argument => argument.required
export const getArgumentElementType = argument => argument.elementType

export default thisModule
